var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeamIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "20px",
    viewBox: "0 0 37 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOR-DEV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dev-company-info",
    transform: "translate(-32.000000, -320.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(32.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4896322,12.4120626 C12.8631025,10.5648004 11.4730377,9.06851803 9.69966595,8.28804975 C10.8141808,7.44446668 11.5453888,6.12059543 11.5453888,4.61815551 C11.5453888,2.07047305 9.47491572,-1.42108547e-14 6.92723326,-1.42108547e-14 C4.38109019,-1.42108547e-14 2.30907775,2.07047305 2.30907775,4.61815551 C2.30907775,6.11905605 3.04028571,7.44138791 4.15326119,8.28497098 C1.71333569,9.35792245 0,11.7916904 0,14.6241591 C0,15.0490294 0.344822278,15.3938517 0.769692585,15.3815366 L10.9419498,15.3815366 C11.5484675,14.2100645 12.4243777,13.1909915 13.4896322,12.4120626",
    id: "Fill-3130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4565355,12.4120626 C24.0830652,10.5648004 25.47313,9.06851803 27.2465017,8.28804975 C26.1319869,7.44446668 25.4007789,6.12059543 25.4007789,4.61815551 C25.4007789,2.07047305 27.471252,-1.42108547e-14 30.0189344,-1.42108547e-14 C32.5650775,-1.42108547e-14 34.6370899,2.07047305 34.6370899,4.61815551 C34.6370899,6.11905605 33.905882,7.44138791 32.7929065,8.28497098 C35.232832,9.35792245 36.9461677,11.7916904 36.9461677,14.6241591 C36.9461677,15.0490294 36.6013454,15.3938517 36.1764751,15.3815366 L26.0042179,15.3815366 C25.3977002,14.2100645 24.52179,13.1909915 23.4565355,12.4120626",
    id: "Fill-3131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6306245,20 C25.0554948,20 25.4003171,19.6674928 25.4003171,19.2410831 C25.4003171,16.4101538 23.6885208,13.9763858 21.2485953,12.9034344 C22.3600314,12.0598513 23.0912394,10.73598 23.0912394,9.23507951 C23.0912394,6.68893644 21.0192269,4.616924 18.4730839,4.616924 C15.9269408,4.616924 13.8549283,6.68893644 13.8549283,9.23507951 C13.8549283,10.73598 14.5861363,12.0598513 15.6975724,12.9034344 C13.2576469,13.9763858 11.5458506,16.4101538 11.5458506,19.2410831 C11.5458506,19.6674928 11.8906729,20 12.3155432,20 L24.6306245,20 Z",
    id: "Fill-3132"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeamIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/team_icon.e0f482bb99289b0f122c916db2b49e35.svg";